export enum MyItemsTab {
    MyBids = 'my-bids',
    MyFavorites = 'my-favorites',
}
